import { Header } from '../components';
import { Pane, Text, Spinner } from 'evergreen-ui';
import React, { useEffect } from 'react';
import getUserRequest from '../queries/getUser';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { setToken, setUser } from '../store/authSlice';
import { setPage } from '../store/sessionSlice';

const Loading = () => (
  <Pane height="100%" padding={16}>
    <Header logoSize={170} />
    <Pane display="flex" justifyContent="center" marginTop={32}>
      <Spinner size={100} />
    </Pane>
  </Pane>
);
const TokenProvider = props => {
  const dispatch = useDispatch();
  const [init, setInit] = React.useState(false);
  const getUserQuery = useMutation(getUserRequest, {
    useErrorBoundary: true,
    onSuccess: async data => {
      if (!data) {
        try {
          localStorage.setItem('wjg_token', '');
        } catch (error) {
          console.log(error);
        }
        return setInit(true);
      }
      dispatch(setUser(data));
      dispatch(setPage('filters'));
      setInit(true);
    },
  });

  useEffect(() => {
    const retrieveUser = async () => {
      try {
        const token = localStorage.getItem('gk_token');
        if (token) {
          dispatch(setToken(token));
          getUserQuery.mutate({ token });
        } else {
          setInit(true);
        }
      } catch (error) {
        console.log(error);
        setInit(true);
      }
    };
    retrieveUser();
  }, []);
  return !init ? <Loading /> : props.children;
};

export default TokenProvider;
